export default __webpack_public_path__ + "static/media/bricks3a.c4067e6a.png";